import { Outlet } from "react-router-dom";
import Header from "../components/controls/Header";
import Footer from "../components/controls/Footer";

const RootLayout = () => {
    return (
        <>
            <div className="fixed-top">
                <Header />
            </div>
            <Outlet />
            <Footer />
        </>
    )
};

export default RootLayout;
